const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				class="input is-hidden"
				tabindex="-1"
				{~Required:Record~}
				{~Disabled:Record~}
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			/>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				class="input is-hidden"
				disabled="disabled"
				{~D:Record.Macro.InputFullProperties~}
				value=""
			/>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				class="input is-hidden"
				disabled="disabled"
				{~D:Record.Macro.InputFullProperties~}
				value=""
			/>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
